var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#314256",
    d: "M6 3a3 3 0 00-3 3v28a3 3 0 003 3h28a3 3 0 003-3V6a3 3 0 00-3-3H6zm2.707 25.31a2.5 2.5 0 10.768.657L15.83 18.91a2.502 2.502 0 001.86-.21l4.458 3.95a2.5 2.5 0 104.2-.832l5.66-9.866a2.5 2.5 0 10-.927-.393l-5.545 9.665a2.493 2.493 0 00-2.855.56l-4.219-3.736a2.5 2.5 0 10-3.525.404l-6.23 9.858zM6 0h28a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
  })));
}

export default SvgProfileStatistics;